import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as ExcessUtil from 'notebook/tables/excess/Util';
import {TypedValue} from 'notebook/tables/TableConstants';
import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';

export default {
  name: 'LEN',
  category: FunctionCategory.TEXT,
  shortDescription: 'Length of a string.',
  description: 'Returns the length of a string.',
  params: [
    {
      name: 'text',
      type: ArgType.singularValue,
      description: 'The string whose length will be returned.',
      coerce: (typedValue: TypedValue): string => formatTypedValue(typedValue, {}, ''),
    },
  ],
  returnType: ExcessUtil.VALUE_TYPES.NUMBER,
  eval: (text: string): number => text.length,
} satisfies EvaluablePrimitiveSpreadsheetFunction;
